export const Headers = { "Content-Type": "application/json" };
export const Method = "POST";

type Result = Promise<Response>;

export const callFetch: (f: () => Result) => Result = async f => {
  const response = await f();
  // repeate one more time
  if (response.status === 401) {
    return await f();
  }
  return response;
};
